import { LifestyleInflationTile } from "../LifestyleInflationTile.js";

/**
 * Phase 13.5 widget — lifestyle-inflation flags. Defaulted hidden in
 * the registry; users opt-in via the customize drawer. The tile itself
 * already returns null when no categories are flagged, so visible-but-
 * unflagged users see nothing rather than empty chrome.
 */
export function LifestyleInflationWidget() {
  const today = new Date().toISOString().slice(0, 10);
  return <LifestyleInflationTile today={today} />;
}
